import { defineComponent as y, getCurrentInstance as k } from "vue";
import { addTracking as m } from "@sunrise/tracking";
const D = y({
  name: "CsGhostButton",
  props: {
    isDisabled: {
      type: Boolean,
      defaultValue: !1
    },
    isSmall: {
      type: Boolean,
      defaultValue: !1
    },
    isCentered: {
      default: !1,
      type: Boolean
    },
    target: {
      default: "_self",
      type: String
    },
    href: {
      default: "",
      type: String
    },
    rel: {
      default: void 0,
      type: String
    },
    ariaLabel: String,
    type: {
      default: "button",
      type: String
    },
    trackingData: Array
  },
  emits: ["click"],
  setup(t, { emit: r }) {
    var i;
    const a = (i = k()) == null ? void 0 : i.proxy;
    let l;
    t.trackingData && (l = m(t.trackingData));
    function u() {
      return !!(a != null && a.$slots.default);
    }
    function f() {
      t.isDisabled || r("click");
    }
    function o() {
      var n;
      return e() && ((n = t.href) == null ? void 0 : n.length) > 0 ? t.href : null;
    }
    function g() {
      var n;
      return e() && t.rel && ((n = t.rel) == null ? void 0 : n.length) > 0 ? t.rel : null;
    }
    function c() {
      return e() ? t.target : void 0;
    }
    function d() {
      return e() ? null : t.type;
    }
    function e() {
      return !!t.href;
    }
    function s() {
      return e() ? "a" : "button";
    }
    return {
      getHref: o,
      getRel: g,
      getTag: s,
      getTarget: c,
      getType: d,
      hasDefaultSlot: u,
      onClick: f,
      tracking: l
    };
  }
});
export {
  D as default
};
